import React from 'react';
import PropTypes from 'prop-types';

import { colorBrandDark } from 'styles/layout/colors';
import IconUpload from 'components/icons/IconUpload';
import CtaLink from 'components/essentials/Cta/CtaLink';

const PDPProductDetailsLinkSection = ({ children, link }) => {
  if (!link) {
    return null;
  }

  return (
    <div>
      <CtaLink
        color="brand-light"
        download
        size="sm"
        spacing="sm"
        styling="solid-button"
        to={link}
      >
        <IconUpload color={colorBrandDark} height={17} width={17} />
        <span>{children}</span>
      </CtaLink>
    </div>
  );
};

PDPProductDetailsLinkSection.propTypes = {
  children: React.node,
  link: PropTypes.string,
};

export default PDPProductDetailsLinkSection;
